module.exports = __webpack_public_path__ + "static/img/timg.18d17d8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/timg.gif
// module id = eyFr
// module chunks = 1